import dayjs, { Dayjs as DayjsT } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isSameOrBefore);

export default dayjs;

export type Dayjs = DayjsT;

export function dateRange(from: string, to: string, includeYear: boolean = false): string {
  const fromDate = dayjs.utc(from);
  const toDate = dayjs.utc(to);

  if (fromDate.month() === toDate.month() && fromDate.year() === toDate.year()) {
    return `${fromDate.format('D')}-${toDate.format(`D MMM${includeYear ? ' YYYY' : ''}`)}`;
  }

  return `${fromDate.format(`D MMM${includeYear ? ' YYYY' : ''}`)} - ${toDate.format(`D MMM${includeYear ? ' YYYY' : ''}`)}`;
}

export function diffYearsMonths(from: Dayjs, to = dayjs.utc()) {
  const totalMonths = dayjs(to).diff(dayjs(from), 'month');
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  const parts = [];

  if (years > 0) {
    parts.push(`${years} yr`);
  }
  if (months > 0) {
    parts.push(`${months} mo`);
  }

  return parts.join(' ') || '0 mo';
}

export function getNumberOfDays(start: string, end: string) {
  const startDate = dayjs.utc(start).startOf('day');
  const endDate = dayjs.utc(end).startOf('day');

  const days: dayjs.Dayjs[] = [];
  let current = startDate;

  while (current.isSameOrBefore(endDate, 'day')) {
    days.push(current);
    current = current.add(1, 'day');
  }

  return days.length;
}
